export const IMAGE_MAX_SIZE = 10000000;
export const APP_WIDTH = 500;

export const APP_HEIGHT = 900;
